import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import theme from '../../../../assets/theme';
import GameDrawingBackgroundSelector from '../../../_molecules/GameDrawingBackgroundSelector';
import { Slide, SlideElement } from '../../../SlideComponents/slide.types';

const DrawingBackgroundRow = ({
  templateId,
  slide,
  onSlideChange,
  className,
  setSelectedElements,
}: {
  templateId: string;
  slide: Slide;
  onSlideChange: (r: Slide) => void;
  className?: string;
  setSelectedElements: (element: SlideElement[] | null) => void;
}) => {
  const { t } = useTranslation('Host');
  const [showMediaModal, setShowMediaModal] = useState(false);
  return (
    <div>
      <UnsplashTitleContainer>
        <span style={{ padding: '1%', color: theme.colors.black }}>
          {t('Drawing background')}
        </span>
      </UnsplashTitleContainer>
      <GameDrawingBackgroundSelector
        slide={slide}
        onSlideChange={onSlideChange}
        id={templateId}
        showDrawingMediaModal={showMediaModal}
        setShowDrawingMediaModal={setShowMediaModal}
        className={className}
        setSelectedElements={setSelectedElements}
      />
      <div style={{ paddingTop: 20, color: theme.colors.black }}>
        <p>{t('Students will draw on top of the background.')}</p>
      </div>
    </div>
  );
};

export default DrawingBackgroundRow;

const UnsplashTitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    border: none;
    padding: 0px 10px;
    margin-bottom: 2px;
    box-shadow: none;
  }
`;
